import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { GlassHouseBrandGroupCardData } from '../../../../../../../../../models/print-cards/glass-house/glass-house-brand-group-card-data';
import { RenderContextComponent } from '../../../../../../../../../models/base/render-context-component';

@Component({
  selector: 'app-glass-house-brand-logo',
  templateUrl: './glass-house-brand-logo.component.html',
  styleUrl: './glass-house-brand-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GlassHouseBrandLogoComponent extends RenderContextComponent {
  @Input() data: GlassHouseBrandGroupCardData;
  setupViews() {}
  setupBindings() {}
}
